import { render, staticRenderFns } from "./course-card.vue?vue&type=template&id=4dfccd88&"
import script from "./course-card.vue?vue&type=script&lang=js&"
export * from "./course-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports